import { isMobileBrowser } from '@/utils/common/device';
import { isLatinoChannel } from '@/utils/common/latino-app';
import useTranslation from 'next-translate/useTranslation';
import { twMerge } from 'tailwind-merge';

const MarketInfo = ({ isMobile }) => {
  const isLatino = isLatinoChannel();
  const { t } = useTranslation('referral');

  const marketInfo = [
    {
      title: 'No.1',
      subTitle: t('supermarket_memo_1')
    },
    {
      title: '100k+',
      subTitle: t('supermarket_memo_2')
    },
    {
      title: '30m',
      subTitle: t('supermarket_memo_3')
    },
    {
      title: '1.5m',
      subTitle: t('supermarket_memo_4')
    }
  ];

  if (isLatino) return null;

  return (
    <div className="w-full">
      <div className={twMerge('p-5', !isMobile && 'text-center')}>
        <div className="enki-heading-xl text-primary-1">{t('referral_supermarket_title')}</div>
        <div className="enki-heading-sm text-surface-100-fg-minor mt-3">{t('referral_supermarket_desc')}</div>
      </div>
      <div className="flex flex-wrap px-0 py-2.5 bg-primary-3">
        {marketInfo.map(item => (
          <div className={twMerge('w-1/2 px-5 py-[9px] box-border', !isMobile && 'w-1/4')} key={item.title}>
            <div className="enki-heading-3xl !text-[34px] text-primary-2">{item.title}</div>
            <div className="enki-body-sm-medium !leading-[34px] text-shade-neutral-base-7">{item.subTitle}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MarketInfo;
